const translations = {
    en: {
        events: {
            bw_rewards: {
                affiliated: {
                    title: "You are special to us",
                    text: "Rates, prizes and many advantages for our Members",
                    button_text: "LOGIN NOW" 
                },
                not_affiliated: {
                    title: "Go. Get. Rewarded.®",
                    text: "Discover all the benefits of our loyalty program",
                    button_text: "JOIN NOW" 
                }
            }
        }
    },
    de: {
        events: {
            bw_rewards: {
                affiliated: {
                    title: "Du bist etwas Besonderes für uns",
                    text: "Tarife, Preise und viele Vorteile für unsere Mitglieder",
                    button_text: "JETZT EINLOGGEN" 
                },
                not_affiliated: {
                    title: "Go. Get. Rewarded.®",
                    text: "Entdecken Sie alle Vorteile unseres Treueprogramms",
                    button_text: "JETZT ANMELDUNGEN" 
                }
            }
        }
    },
    es: {
        events: {
            bw_rewards: {
                affiliated: {
                    title: "Eres especial para nosotros",
                    text: "Tarifas ,premios y muchas ventajas para nuestros miembros",
                    button_text: "ENTRA AHORA" 
                },
                not_affiliated: {
                    title: "Subscribanse y empiece a obtener puntos, desde ahora ",
                    text: "Descubra todos los beneficios de nuestro programa Best Western Rewards ",
                    button_text: "Unanse a nuestro programa de lealtad" 
                }
            }
        }
    },
    fr: {
        events: {
            bw_rewards: {
                affiliated: {
                    title: "Vous êtes spécial pour nous",
                    text: "Tarifs, prix et nombreux avantages pour nos membres",
                    button_text: "CONNECTEZ-VOUS MAINTENANT" 
                },
                not_affiliated: {
                    title: "Go. Get. Rewarded.®",
                    text: "Découvrez tous les avantages de notre programme de fidélité",
                    button_text: "REJOIGNEZ-NOUS" 
                }
            }
        }
    },
    it: {
        events: {
            bw_rewards: {
                affiliated: {
                    title: "Per noi sei speciale",
                    text: "Tariffe, premi e tanti vantaggi per te che sei nostro Socio",
                    button_text: "ACCEDI ORA" 
                },
                not_affiliated: {
                    title: "Go. Get. Rewarded.®",
                    text: "Scopri tutti i vantaggi del nostro programma fedeltà",
                    button_text: "ISCRIVITI ORA" 
                }  
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/events/BwRewards.js